import React from "react";

import { ClientPractiseConnectionsDetail } from "@/components/features/client/ClientPractiseConnectionsDetail";

export const ClientPractiseConnectionsDetailRoute: React.FC = () => (
  <ClientPractiseConnectionsDetail />
);
